import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArrowUpTwoSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.128 6.82098L7.083 3.73998L7.041 12.934C7.04047 13.0747 7.01221 13.2139 6.95783 13.3436C6.90344 13.4734 6.82401 13.5911 6.72407 13.6901C6.62412 13.7891 6.50564 13.8675 6.37539 13.9206C6.24513 13.9738 6.10568 14.0008 5.965 14C5.8244 13.9993 5.6853 13.971 5.55567 13.9165C5.42604 13.8621 5.3084 13.7826 5.2095 13.6827C5.11059 13.5828 5.03235 13.4643 4.97924 13.3341C4.92613 13.204 4.89921 13.0646 4.9 12.924L4.941 3.73198L1.865 6.77198C1.76523 6.87107 1.64691 6.94952 1.51681 7.00285C1.3867 7.05617 1.24736 7.08334 1.10675 7.08278C0.966143 7.08222 0.827022 7.05396 0.697344 6.9996C0.567666 6.94524 0.449974 6.86586 0.350995 6.76598C0.151199 6.56406 0.0397146 6.29109 0.0410271 6.00703C0.0423396 5.72298 0.156342 5.45105 0.357995 5.25098L5.407 0.250983C5.57276 0.0870924 5.79684 -0.00424194 6.02994 -0.00292969C6.26305 -0.00161743 6.48608 0.0922356 6.65 0.257983L11.65 5.31098C11.8497 5.51274 11.9612 5.78554 11.9599 6.06943C11.9586 6.35333 11.8446 6.62509 11.643 6.82498C11.5433 6.92423 11.425 7.00286 11.2949 7.05637C11.1647 7.10988 11.0254 7.13723 10.8847 7.13686C10.744 7.13649 10.6047 7.1084 10.4749 7.0542C10.3451 7 10.2272 6.92075 10.128 6.82098Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default ArrowUpTwoSVG;
